import SectionItem from '../../Layout/SectionItem/SectionItem'
import QuestionContainer from './QuestionContainer/QuestionContainer'
import SurveyContainer from './SurveyContainer/SurveyContainer'
import TaskContainer from './TaskContainer/TaskContainer'

const CommunicationTaskAction = (props) => {
    const {
        questionList,
        onAddQuestion,
        onUpdateAnswer,
        onRemoveAnswer,
        onQuestionSave,
        onQuestionEdit,
        onQuestionRemove,
        onQuestionReduce,
        disableSurveys,
        section,
        onSave,
        onAction,
    } = props
    return (
        <SectionItem>
            <QuestionContainer
                questionList={questionList}
                onAddQuestion={(questionLength, question) =>
                    onAddQuestion(questionLength, question)
                }
                onUpdateAnswer={(questionIndex, answerIndex, answer, disabled) =>
                    onUpdateAnswer(questionIndex, answerIndex, answer, disabled)
                }
                onRemoveAnswer={(questionIndex, answerIndex) =>
                    onRemoveAnswer(questionIndex, answerIndex)
                }
                onQuestionSave={(questionIndex, question) =>
                    onQuestionSave(questionIndex, question)
                }
                onQuestionEdit={(questionIndex, question) =>
                    onQuestionEdit(questionIndex, question)
                }
                onQuestionRemove={(index) => onQuestionRemove(index)}
                onQuestionReduce={(index, question) => onQuestionReduce(index, question)}
                isDisabled={section.isDisabled}
            />
            <TaskContainer isDisabled={section.isDisabled} onTaskSave={onSave} onTask={onAction} />
            {!disableSurveys && <SurveyContainer
                isDisabled={section.isDisabled}
                onSurveySave={onSave}
                onSurvey={onAction}
            />}
        </SectionItem>
    )
}

export default CommunicationTaskAction
